<template>
  <div>
  <v-dialog
    v-model="dialog"
    transition="slide-y-transition"
    width="600"
    persistent
  >
    <template v-slot:activator="{ on, attrs }">
      <v-list-item
        v-bind="attrs"
        v-on="on"
      >
        <v-list-item-action>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-card class="grey lighten-5">
      <v-card-title class="grey lighten-4">
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = !dialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="form">
          <v-autocomplete
            label="Nome da obra de arte especial"
            v-model="params.ponte"
            :items="options.pontes"
            item-text="nome" item-value="codigo"
            clearable
            multiple
            persistent-hint
            hint="Ao não selecionar nenhuma opção todos os registros são exibidos"
          />
          <v-autocomplete
            label="Rodovia"
            v-model="params.rodovia"
            :items="options.rodovias"
            clearable
            multiple
            persistent-hint
            hint="Ao não selecionar nenhuma opção todos os registros são exibidos"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="reset()">Limpar</v-btn>
        <v-btn @click="addLayer()" color="primary">Pesquisar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialog2" width="700">
    <v-card>
      <v-card-title>
        Ponte
        <v-spacer />
        <v-btn icon @click="dialog2 = !dialog2">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-list>,
        <v-list-item>
          Obra de Arte Especial: {{feature.properties['nome_oae']}}
        </v-list-item>
        <v-list-item>
          Largura: {{feature.properties['largura'] ? feature.properties['largura'] + ' m' : ''}}
        </v-list-item>
        <v-list-item>
          Comprimento: {{feature.properties['comp'] ? feature.properties['comp'] + ' m' : ''}} 
        </v-list-item>
      </v-list>
      <!--v-carousel>
        <v-carousel-item
          v-for="(imagem, i) in imagemUrl"
          :key="i"
          :src="imagem"
        >
        </v-carousel-item>
      </v-carousel-->
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import * as L from 'leaflet'
import { getBounds } from '@/domain/library'

import { ponte } from '@/api/vue-exemplo'

export default {
  name: 'Pontes',
  data: () => ({
    name: 'der:pontes_pto_p31982',
    title: 'Pontes',
    dialog: false,
    dialog2: false,
    feature: {
      properties: {}
    },
    imagemUrl: [],
    params: {
      ponte: '',
      rodovia: ''
    },
    options: {
      pontes: [],
      rodovias: []
    },
    template: [
      {text: 'Obra de Arte Especial', value: 'nome_oae'},
      {text: 'Largura', value: 'largura'},
      {text: 'Comprimento', value: 'comp'},
    ]
  }),
  mounted () {
    this.getPontes()
    this.getRodovias()
  },
  methods: {
    reset () {
      this.$refs.form.reset()

      this.removeLayer()
      this.$root.$emit('fitBounds', getBounds())

      this.dialog = false
    },
    addLayer () {
      this.removeLayer()

      var params = {
        service: 'wfs',
        version: '2.0.0',
        outputFormat: 'application/json',
        exceptions: 'application/json',
        request: 'GetFeature',
        typeNames: this.name,
        srsName: 'EPSG:4674'
      }

      var paramsWms = {
        layers: this.name,
        format: 'image/png',
        transparent: true,
        pane: 'overlayPane',
        title: this.title
      }

      if (this.params.ponte.length != 0) {
        params.cql_filter = '('
        for (var ponte of this.params.ponte) {
          params.cql_filter += "id='" + ponte + "' OR "
        }
        params.cql_filter = params.cql_filter.slice(0, params.cql_filter.length-4) + ')'
        paramsWms.cql_filter = params.cql_filter
      }

      if (this.params.rodovia.length != 0) {
        if(params.cql_filter) {
          params.cql_filter = params.cql_filter + " AND ("
        } else {
          params.cql_filter = '('
        }
        for (var rodovia of this.params.rodovia) {
          params.cql_filter += "rodovia='" + rodovia + "' OR "
        }
        params.cql_filter = params.cql_filter.slice(0, params.cql_filter.length-4) + ")"
        paramsWms.cql_filter = params.cql_filter
      }

      this.wmsLayer = L.tileLayer.wms(process.env.VUE_APP_GEOSERVER, paramsWms)

      this.$root.$emit('addWmsLayer', this.wmsLayer, null, true)

      axios.get(process.env.VUE_APP_GEOSERVER, {
        params: params
      })
        .then(response => {
          this.geojson = L.geoJson(response.data, {
            onEachFeature: (feature, layer) => {
              var action = () => { 
                this.dialog2 = true
                this.feature = feature
                if(this.feature.properties.largura) {
                  this.feature.properties.largura = feature.properties.largura.toLocaleString('pt-BR', { style: 'decimal' })
                }
                if(this.feature.properties.comp) {
                  this.feature.properties.comp = feature.properties.comp.toLocaleString('pt-BR', { style: 'decimal' })
                }
                /*if(feature.properties.link2) {
                  this.imagemUrl = feature.properties.link2.split(';')
                  for(var i = 0; i < this.imagemUrl.length; i++) {
                    this.imagemUrl[i] = 'mapageo/' + this.imagemUrl[i]
                  }
                }*/
              }
              layer.on('click', action)
            },
            pointToLayer: function (feature, latlng) {
              return L.circleMarker(latlng, {
                opacity: 0,
                fillOpacity: 0
              })
            }
          })

          this.$root.$emit('addGeoJson', this.geojson)
        })
        .catch(error => {
          console.log(error)
        })

      this.dialog = false
    },
    removeLayer () {
      if (this.geojson) {
        this.$root.$emit('removeGeoJson', this.geojson)
        this.$root.$emit('removeWmsLayer', this.wmsLayer)
      }
    },
    getPontes () {
      ponte.getNomes()
        .then(response => {
          this.options.pontes = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getRodovias() {
      ponte.getRodovias()
        .then(response => {
          this.options.rodovias = response.data
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
